import React from "react";
import styled from "styled-components";
// import { Watch } from "scrollmonitor-react";

class LazyImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      src: "",
      srcSet: "",
      imageLoaded: false,
    };
  }
  componentDidMount() {
    this.setState({
      src: this.props.blurSrc,
      srcSet: this.props.blurSrc,
      fullSrc: this.props.fullSrc[0],
      fullSrcSet:
        this.props.fullSrc[2] +
        " 1000w, " +
        this.props.fullSrc[1] +
        " 2000w, " +
        this.props.fullSrc[0] +
        " 2500w",
    });
  }
  loadImage = () => {
    this.setState({ imagesLoaded: true });
  };
  render() {
    return (
      <img
        src={
          this.state.imagesLoaded
            ? this.state.fullSrc
              ? this.state.fullSrc
              : this.state.src
            : this.state.src
        }
        srcSet={
          this.state.imagesLoaded
            ? this.state.fullSrc
              ? this.state.fullSrcSet
              : this.state.srcSet
            : this.state.srcSet
        }
        alt={this.props.alt}
        onLoad={this.loadImage}
        height="auto"
        width="100%"
      />
    );
  }
}

LazyImage.defaultProps = {};

// export default Watch(LazyImage);
export default LazyImage;



// WEBPACK FOOTER //
// ./src/components/LazyImage.js